import { useEffect, useCallback } from 'react';

const useDetectScrolledToBottom = (node, onBottomScroll) => {
  const handleScroll = useCallback(() => {
    if (node.current) {
      const { scrollTop, scrollHeight, clientHeight } = node.current;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        onBottomScroll();
      }
    }
  }, [onBottomScroll]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const currentNode = node.current;
    if (currentNode) {
      currentNode.addEventListener('scroll', handleScroll);

      return () => currentNode.removeEventListener('scroll', handleScroll);
    }
  }, [node, handleScroll]);
};

export { useDetectScrolledToBottom };
